"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormDefaults = void 0;
var React = require("react");
var lodash_1 = require("lodash");
var date_picker_1 = require("./date-picker");
var country_select_1 = require("./country-select");
var time_zone_select_1 = require("./time-zone-select");
var sport_select_1 = require("./sport-select");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
require("./form-element.scss");
/**
 * Due to the way we're using react hook form with our custom components, we cant
 * dependably use default values, so we use this instead:
 * https://react-hook-form.com/api/#register
 */
var useFormDefaults = function (dataset, setupFn, dependencyArray) {
    React.useEffect(function () {
        if (dataset) {
            // the timing for this is really weird, so we bounce this
            // to the end of the event loop via set timeout
            setTimeout(function () {
                setupFn(dataset);
            }, 0);
        }
    }, dependencyArray);
};
exports.useFormDefaults = useFormDefaults;
/**
 * FormElementHook provides a simple way to build robust and full-featured form inputs
 * while leveraging the awesomeness that is react-hook-form.
 */
var FormElementHook = /** @class */ (function (_super) {
    __extends(FormElementHook, _super);
    function FormElementHook(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = React.createRef();
        return _this;
    }
    FormElementHook.prototype.componentDidUpdate = function () {
        if (Object.keys(this.getErrors(this.props)).length > 0 &&
            this.inputRef.current &&
            typeof this.inputRef.current.scrollIntoView == "function") {
            this.inputRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };
    FormElementHook.prototype.componentDidMount = function () {
        if (this.props.inputRef) {
            this.props.inputRef(this.inputRef.current);
        }
    };
    FormElementHook.prototype.getErrors = function (props) {
        return (props.useHookResponse.errors || {})[props.field] || {};
    };
    FormElementHook.prototype.renderElement = function () {
        var _this = this;
        var _a = this.props, useHookResponse = _a.useHookResponse, field = _a.field, type = _a.type, inputClassName = _a.inputClassName, options = _a.options, dateProps = _a.dateProps, fieldSecondary = _a.fieldSecondary, label = _a.label, maxLength = _a.maxLength, isInline = _a.isInline, placeholder = _a.placeholder, disabled = _a.disabled, checked = _a.checked;
        var fieldName = field.toString();
        var className = inputClassName || "";
        if (type == "select") {
            return (React.createElement("div", { className: "SelectBox" },
                React.createElement("select", { ref: this.inputRef, className: "SelectBox-options " + className, name: fieldName, id: fieldName, disabled: disabled }, lodash_1.map(options, function (o) { return (React.createElement("option", { key: o.value, value: o.value }, o.text)); }))));
        }
        if (type == "gender") {
            return (React.createElement("div", { className: "SelectBox" },
                React.createElement("select", { ref: this.inputRef, className: className + " SelectBox-options gender", name: fieldName, disabled: disabled },
                    React.createElement("option", { value: "" }),
                    React.createElement("option", { value: "male" }, "Male"),
                    React.createElement("option", { value: "female" }, "Female"))));
        }
        if (type == "email") {
            return (React.createElement("input", { ref: this.inputRef, className: "Input " + className, maxLength: 150, type: "email", id: fieldName, name: fieldName, placeholder: placeholder, disabled: disabled }));
        }
        // if (type == "phone") {
        //   return (
        //     <PhoneNumber
        //       className={inputClassName}
        //       form={form}
        //       field={field}
        //       typeField={fieldSecondary}
        //       disabled={disabled}
        //     />
        //   );
        // }
        if (type == "date") {
            return (React.createElement(date_picker_1.default, { useHookResponse: useHookResponse, inputRef: this.inputRef, name: fieldName, dateProps: dateProps, className: "Input", disabled: disabled, placeholderText: placeholder }));
        }
        if (type == "checkbox") {
            return (React.createElement(teamsnap_ui_1.Checkbox, __assign({ name: field, inputProps: {
                    disabled: disabled,
                    ref: this.inputRef,
                }, label: label, mods: "u-padBottomNone", isInline: isInline }, { id: fieldName, disabled: disabled })));
        }
        if (type == "radio") {
            return lodash_1.map(options, function (option) { return (React.createElement(teamsnap_ui_1.Radio, __assign({ key: option.value, name: option.value, label: option.text, group: field, isInline: isInline, inputProps: {
                    ref: _this.inputRef,
                } }, { id: fieldName, disabled: disabled }))); });
        }
        if (type == "country") {
            return React.createElement(country_select_1.default, { id: fieldName, name: fieldName, inputRef: this.inputRef, disabled: disabled });
        }
        if (type == "timezone") {
            return React.createElement(time_zone_select_1.default, { id: fieldName, name: fieldName, inputRef: this.inputRef, disabled: disabled });
        }
        if (type == "sport") {
            return React.createElement(sport_select_1.default, { id: fieldName, name: fieldName, inputRef: this.inputRef, disabled: disabled });
        }
        if (type == "textarea") {
            return (React.createElement("textarea", { ref: this.inputRef, className: "Input " + className, maxLength: maxLength, name: fieldName, id: fieldName, placeholder: placeholder, disabled: disabled }));
        }
        // if (type == "state") {
        //   const country = form[fieldSecondary];
        //   return (
        //     <StateField
        //       className={className}
        //       name={fieldName}
        //       value={value}
        //       onChange={this.onChange}
        //       country={country}
        //       disabled={disabled}
        //     />
        //   );
        // }
        if (type == "password") {
            return (React.createElement("input", { ref: this.inputRef, className: "Input " + className, maxLength: 260, type: "password", name: fieldName, id: fieldName, disabled: disabled }));
        }
        return (React.createElement("input", { ref: this.inputRef, className: "Input " + className, type: "text", maxLength: maxLength, name: fieldName, id: fieldName, placeholder: placeholder, disabled: disabled }));
    };
    FormElementHook.prototype.render = function () {
        var _a = this.props, className = _a.className, label = _a.label, field = _a.field, type = _a.type, labelHidden = _a.labelHidden;
        var fieldErrors = this.getErrors(this.props) || { message: null };
        var fieldName = field.toString();
        var showLabel = label && type != "checkbox";
        return (React.createElement("div", { className: "FieldGroup " + fieldName + " " + (Object.keys(fieldErrors).length > 0 ? "error" : "") + (className || "") },
            showLabel && (React.createElement("label", { className: "FieldGroup-label u-padTopMd u-padBottomSm" + (labelHidden ? " u-hiddenVisually" : ""), htmlFor: fieldName }, label)),
            this.renderElement(),
            fieldErrors && fieldErrors.message && React.createElement("div", { className: "validation-error" }, fieldErrors.message)));
    };
    return FormElementHook;
}(React.Component));
exports.default = FormElementHook;
//# sourceMappingURL=form-element-hook.js.map